import React, { useState, useEffect } from 'react'

export default function Modal({
  visible, closeModal, styles, mode, children, action, actionText, cancelAction,
  cancelActionText, disableAction, showConfirmation, confirmationText, actionIcon,
  cancelActionIcon, wrapperClasses, wrapperStyles, footerLeftActions, footerMiddleActions,
  allowNoConfirmation, setConfirmationValue
}) {
  const [confirmation, setConfirmation] = useState(false)

  useEffect( () => {
    if (setConfirmationValue) {
      setConfirmationValue(confirmation)
    }
  }, [confirmation])

  return (
    <>
      { visible &&
        <div className='main-modal'>
          <div className='overlay' onClick={ closeModal }/>
          <div className={ `modal-content flex-box flex-column ${ mode || 'medium' }` }>
            <div className='modal-body' style={{ height: '100%' }}>
              <div className='close-modal'
                onClick={ closeModal }
              >
                <i className='fa-solid fa-xmark'/>
              </div>
              <div className={ `flex-box flex-column ${ wrapperClasses || '' }` } style={ wrapperStyles || {} }>
                { children }
              </div>
            </div>

            { (action || cancelAction) &&
              <div className='modal-footer flex-box content-end flex-column'>
                { showConfirmation &&
                  <div
                    className='flex-box content-end pointer m-t-10 m-b-20'
                    onClick={ () => setConfirmation( prevState => !prevState ) }
                  >
                    <input
                      type='checkbox'
                      className='m-r-10'
                      checked={ confirmation }
                      onChange={ () => {} }
                    />
                    { confirmationText }
                  </div>
                }

                <div className='flex-box content-space-between items-center'>
                  { footerLeftActions ? footerLeftActions() : <div className='flex-1'/> }
                  { footerMiddleActions ? footerMiddleActions() : <div className='flex-1'/> }
                  <div className='flex-box flex-1 content-end'>
                    <div className='flex-box items-center content-space-between'>
                      { cancelAction &&
                        <button
                          type='button'
                          className='btn btn-primary m-r-10 flex-box'
                          onClick={ cancelAction }
                        >
                          { cancelActionIcon &&
                            <i className={ `${ cancelActionIcon } m-r-10` }/>
                          }
                          { cancelActionText || Website.translations.cancel }
                        </button>
                      }

                      { action &&
                        <button
                          type='button'
                          className='btn btn-primary flex-box'
                          onClick={ action }
                          disabled={ disableAction || (showConfirmation && !confirmation && !allowNoConfirmation) }
                        >
                          { actionIcon &&
                            <i className={ `${ actionIcon } m-r-10` }/>
                          }
                          { actionText || Website.translations.save }
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </>
  )
}
